// Module
var code = "<button type=\"button\" class=\"MultiLineThumbnailSelector\">\n  <div class=\"embed-responsive\">\n    <img class=\"embed-responsive-item\" alt=\"...\" />\n  </div>\n  <div class=\"MultiLineThumbnailSelector__caption\">\n    <h3></h3>\n  </div>\n</button>\n";
// Exports
export default code;